module.exports = __webpack_public_path__ + "assets/d332d9b137cb7b5273fa90ae82d6ef45.png";